import { useEffect, useRef } from "react";
import { OverlayView } from '@react-google-maps/api';

const OverlaySky = ({ taiwanSize, position, map }) => {
    const overlayRef = useRef(null);

    useEffect(() => {
        if (overlayRef.current) {
            overlayRef.current.setMap(null);
        }

        const overlay = new window.google.maps.OverlayView();
        overlay.onAdd = function () {
            const layer = document.createElement('div');
            layer.style.position = 'absolute';

            const dw = taiwanSize.width * 3;
            const dh = taiwanSize.height * 2.4;

            const cloudArr = [
                { img: "./map/nebula_blue.png", pos: "-90%, -100%", w: taiwanSize.width * 3, h: taiwanSize.width * 3, r: 0, opacity: "1" },
                { img: "./map/nebula_blue.png", pos: "-90%, -100%", w: taiwanSize.width * 3, h: taiwanSize.width * 3, r: 20, opacity: "1" },
                { img: "./map/nebula_blue.png", pos: "-100%, -110%", w: taiwanSize.width * 3, h: taiwanSize.width * 3, r: 0, opacity: "1" },
                { img: "./map/nebula_blue.png", pos: "-70%, -130%", w: taiwanSize.width * 3, h: taiwanSize.width * 3, r: 10, opacity: "1" },
                { img: "./map/nebula_blue.png", pos: "-90%, -120%", w: taiwanSize.width * 3, h: taiwanSize.width * 3, r: 20, opacity: "1" },
                { img: "./map/nebula_blue.png", pos: "-100%, -80%", w: taiwanSize.width * 3, h: taiwanSize.width * 3, r: 190, opacity: "1" },
                { img: "./map/nebula_purple.png", pos: "10%, -0%", w: taiwanSize.width * 2, h: taiwanSize.width * 2, r: 190, opacity: "1" },
                { img: "./map/nebula_purple.png", pos: "0%, 10%", w: taiwanSize.width * 2, h: taiwanSize.width * 2, r: 190, opacity: "1" },
                { img: "./map/nebula_purple.png", pos: "30%, -10%", w: taiwanSize.width * 2, h: taiwanSize.width * 2, r: 190, opacity: "1" },
                { img: "./map/nebula_purple.png", pos: "30%, 20%", w: taiwanSize.width * 2, h: taiwanSize.width * 2, r: 190, opacity: "1" },
                { img: "./map/nebula_purple.png", pos: "-20%, 40%", w: taiwanSize.width * 2, h: taiwanSize.width * 2, r: 190, opacity: "1" },
            ];

            cloudArr.forEach((v, k) => {
                const img = document.createElement('img');
                img.src = v.img;
                img.style.position = 'absolute';
                img.style.width = `${v.w}px`;
                img.style.height = `${v.h}px`;
                img.style.transform = `translate(${v.pos}) rotate(${v.r}deg)`;
                img.style.opacity = `${v.opacity}`;
                img.style.transition = 'width 1s ease, height 1s ease, transform 1s ease, opacity 1s ease';
                layer.appendChild(img);
            });

            const images = ["./staticstar.png", "./flashingstar.png", "./taiwanCloud.png"];
            images.forEach(src => {
                const img = document.createElement('img');
                img.src = src;
                img.style.objectFit = 'contain';
                img.style.position = 'absolute';
                img.style.top = '50%';
                img.style.left = '50%';
                img.style.width = `${dw*1.5}px`;
                img.style.opacity = '.9';
                img.style.transform = 'translate(-50%, -50%)';
                layer.appendChild(img);
            });

            this.div = layer;
            const panes = this.getPanes();
            panes.overlayLayer.appendChild(layer);
        };

        overlay.draw = function () {
            if (!this.div) return;

            const overlayProjection = this.getProjection();
            const sw = overlayProjection.fromLatLngToDivPixel(position);

            const div = this.div;
            div.style.left = `${sw.x}px`;
            div.style.top = `${sw.y}px`;
        };

        overlay.onRemove = function () {
            this.div.parentNode.removeChild(this.div);
            this.div = null;
        };

        overlay.setMap(map);
        overlayRef.current = overlay;

        return () => {
            overlay.setMap(null);
        };
    }, [position,taiwanSize, map]);

    return null;
};

export default OverlaySky;
